module.exports = __webpack_public_path__ + "img/cp1-2.ccda178b.jpg";